import { useSyncExternalStore } from 'react';
import { getTargetAttackUiSnapshot, subscribeTargetAttackUi } from '../../state/targetAttackUiStore.ts';
import { TARGET_ATTACK_DOM } from './targetAttackDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function TargetAttackHud() {
  const d = TARGET_ATTACK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeTargetAttackUi,
    getTargetAttackUiSnapshot,
    getTargetAttackUiSnapshot,
  );

  const MODE_LABELS: Record<'CLASSIC' | 'ARCADE' | 'ZEN', string> = {
    CLASSIC: t('game.classic'),
    ARCADE: t('game.arcade'),
    ZEN: t('game.zen'),
  };

  const hearts =
    s.lives !== null
      ? (() => {
        const maxLives = 3;
        const L = Math.max(0, s.lives);
        return '❤️'.repeat(L) + '🖤'.repeat(Math.max(0, maxLives - L));
      })()
      : '';

  const timerText =
    s.timeLeftSec !== null && s.timeLeftSec !== undefined ? `⏱ ${s.timeLeftSec}s` : '';

  const levelText =
    s.currentLevel !== null && s.currentLevel !== undefined ? `${t('game.level')} ${s.currentLevel}` : '';

  const progressPct =
    s.levelProgress !== null && s.levelProgress !== undefined
      ? Math.round(Math.max(0, Math.min(1, s.levelProgress)) * 100)
      : 0;
  const showLevelProgress = s.gameMode !== 'ARCADE';

  return (
    <div id={d.root} className="target-attack-ui" hidden={!s.hudVisible}>
      <header className="target-attack-ui__header" aria-label={t('game.score')}>
        <div className="target-attack-ui__lives">{hearts}</div>
        <div className="target-attack-ui__center">
          <div className="target-attack-ui__p1" hidden={!s.split}>
            P1 {s.player1Score ?? ''}
          </div>
          <div className="target-attack-ui__score-block" hidden={s.split}>
            <span className="target-attack-ui__score-label">{t('game.points')}</span>
            <span className="target-attack-ui__score">{s.score}</span>
          </div>
          <div className="target-attack-ui__p2" hidden={!s.split}>
            P2 {s.player2Score ?? ''}
          </div>
        </div>
        <div
          className={
            s.timerUrgent
              ? 'target-attack-ui__timer target-attack-ui__timer--urgent'
              : 'target-attack-ui__timer'
          }
        >
          {timerText}
        </div>
      </header>
      <footer className="target-attack-ui__footer">
        <span className="target-attack-ui__mode">
          {s.gameMode !== null ? MODE_LABELS[s.gameMode] ?? s.gameMode : ''}
        </span>
        <span className="target-attack-ui__level">{levelText}</span>
        {showLevelProgress ? (
          <div className="target-attack-ui__progress" aria-hidden="true">
            <div
              className="target-attack-ui__progress-fill"
              style={{ width: `${progressPct}%` }}
            />
          </div>
        ) : null}
        <span className="target-attack-ui__streak">{s.streak > 0 ? `🔥 ×${s.streak}` : ''}</span>
        <span className="target-attack-ui__combo">
          {s.comboCount !== null ? `COMBO ×${s.comboCount}` : ''}
        </span>
      </footer>
    </div>
  );
}
